import { handleLogout } from 'ComponentsV2/ProjectDashboard/utils/handleLogout';
import * as ls from 'local-storage';
import { apiInterceptor } from 'utils/apiInterceptor';

let authBearer = null;
//sponsor multi-login handling
const setAuthBearer = () => {
    try {
        if (window.SPONSOR_AUTH) {
            authBearer = `Bearer ${window.SPONSOR_AUTH?.access_token}`;
        } else {
            const auth = ls.get('auth');
            authBearer = auth && `Bearer ${auth?.access_token}`;
        }
    } catch (error) {
        console.error(error);
    }
};

/**
 * gets the current user based from authorisation token
 */
export async function getUser() {
    setAuthBearer();
    const auth = ls.get('auth');
    if (!auth) return null;

    const headers = {
        'Content-Type': 'application/json',
    };
    if (!authBearer) {
        if (auth && auth?.access_token) {
            authBearer = `Bearer ${auth?.access_token}`;
        }
    }

    if (authBearer) {
        headers.Authorization = authBearer;
    }

    const { response } = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/users/profile`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    if (response.status === 403) {
        return handleLogout();
    }

    return await response.json();
}
